import Footer from "./components/Footer";
import Header from "./components/Header";
import Loader from "./components/Loader";
import Body from "./components/Body";
import Work from "./components/Work";
import About from "./components/About";
import Show from "./components/Show";
import { useState, useEffect } from "react";
import { client } from "./api/Client";

export default function App() {
  let [show, setShow] = useState(false);
  let [load, setLoad] = useState(false);
  
  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 2000);
    client
      .get("/GetShow")
      .then((res) => {
        setShow(res.data.Show);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);
  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="App">
          <Header />
          <Body />
          <Work />
          <About />
          <Footer />
          {show ? (
            show.map((item) => {
              return (
                <>
                  <Show Show={item.ShowURL} Id={ item._id } />
                </>
              );
            })
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
}
